import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { SquadProvider } from './lib/SquadProvider.tsx';
import './styles/modernist.css';
import './styles/app.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    <SquadProvider>
      <App />
    </SquadProvider>
  </StrictMode>,
);
